import { render, staticRenderFns } from "./ScrollDisplay.vue?vue&type=template&id=0a7c421d&scoped=true&"
import script from "./ScrollDisplay.vue?vue&type=script&lang=ts&"
export * from "./ScrollDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./ScrollDisplay.vue?vue&type=style&index=0&id=0a7c421d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7c421d",
  null
  
)

export default component.exports